<script>
export default {
    methods: {
        $can(permissionName) {
            if (this.permissions) {
                return this.permissions.indexOf(permissionName) !== -1;
            } else {
                return false;
            }
        },
    },
};
</script>
